import { canManageFxMcp } from "@/modules/fx-ai/access";
import { FxAiSetup } from "@/modules/fx-ai/setup";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(app)/_main-layout/_exchange/exchange/mcp-setup",
)({
  beforeLoad: ({ context }) => {
    if (!canManageFxMcp(context)) {
      throw redirect({ to: "/exchange" });
    }
  },
  component: FxAiExchangePage,
});

function FxAiExchangePage() {
  const { accessToken } = Route.useRouteContext();
  return <FxAiSetup accessToken={accessToken} />;
}
